import { useQuery } from "@apollo/client";
import Loading from "shared/components/Loading";
import Error from "shared/components/Error";
import graphql from "utils/api/graphql";
import { useParams } from "react-router-dom";
import Card from "shared/components/Card";
import Button from "shared/components/Button";
import { ASSET_TYPES } from "utils/constants";
import {
  Add,
  ArrangeSquare,
  SquareUp,
} from "shared/components/Svg/Icons/Outline";
import { NAME_SPACES } from "shared/locales/constants";
import { useTranslation } from "react-i18next";

const Account = ({ icon, amount }) => {
  const { icon: flag, mirror } = Object.values(ASSET_TYPES).find(
    (value) => value.type === icon
  );
  return (
    <div className="account__horizontal__card">
      <span className="account__horizontal__card--icon">{flag}</span>
      <div className="account__horizontal__card--value">
        <span className="account__horizontal__card--label">{mirror}</span>
        <div className="--baseline">
          <span className="--value">
            {new Intl.NumberFormat("en", {
              notation: "compact",
              compactDisplay: "short",
              maximumFractionDigits: 1,
            }).format(amount)}
          </span>
          <span className="--currency">{mirror}</span>
        </div>
      </div>
    </div>
  );
};

const Address = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.XO.ACCOUNT);
  const LIST = t("LIST", { returnObjects: true });
  const params = useParams();
  const { data, loading, error } = useQuery(graphql.queries.ADDRESS, {
    variables: {
      where: { id: params.id },
    },
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const { address } = data;
  const { token } = address;

  return (
    <Card
      head={
        <Account
          key={`token-${token.id}`}
          icon={token.type}
          amount={token?.balances?.[0]?.value ?? 0}
        />
      }
      actions={[
        <Button
          key={LIST.HEADER.ACTIONS.ADD_AMOUNT}
          mode="primary"
          onClick={() => {}}
          icon={<Add height={16} width={16} />}
        >
          {LIST.HEADER.ACTIONS.ADD_AMOUNT}
        </Button>,
        <Button
          key={LIST.HEADER.ACTIONS.CONVERT}
          mode="outline"
          onClick={() => {}}
          icon={<ArrangeSquare height={16} width={16} />}
        >
          {LIST.HEADER.ACTIONS.CONVERT}
        </Button>,
        <Button
          key={LIST.HEADER.ACTIONS.SEND}
          mode="outline"
          onClick={() => {}}
          icon={<SquareUp height={16} width={16} />}
        >
          {LIST.HEADER.ACTIONS.SEND}
        </Button>,
      ]}
    ></Card>
  );
};

export default Address;
